<div class="flex flex-column justify-content-center align-items-center gap-4">
  <div
    [class]="
      'flex justify-content-center align-items-center border-circle w-4rem h-4rem ' + bgColor
    "
  >
    <i [class]="'text-4xl  pi ' + icon + ' ' + iconColor"></i>
  </div>
  <div class="flex justify-content-center text-center align-items-center w-16rem">
    <p class="text-1xl font-bold">{{ message }}</p>
  </div>
  <p-button class="primary-button" label="Aceptar" (click)="closeDialog()" />
</div>
